import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const initialState = () => ({
	user: null,
	token: null,
	activeCustomer: null,
	activeCompany: null,
	activeBuilding: null,

	users: [],
	getUser: {},
	allowCustomerApiKey: false
});

export default {
	namespaced: true,
	state: initialState(),
	mutations,
	actions,
	getters
};
